import { fetchForm } from "data/api";
import { mapValue } from "data/utils";

const parseFieldsOrAttributes = (
    fields,
    shouldURIEncode = false,
    prefix = "ea"
) => {
    const rawValues = {};
    if (fields?.length > 0) {
        fields.forEach(
            (field) => (rawValues[`${prefix}.${field.name}`] = field.value)
        );
    }
    /* istanbul ignore else */
    if (shouldURIEncode) {
        Object.entries(rawValues).forEach(([key, value]) => {
            rawValues[key] = mapValue(value, encodeURIComponent);
        });
    }
    return rawValues;
};

const withFormTokens = async (
    context: any,
    otherContext: any = {},
    shouldURIEncode = false
) => {
    try {
        if (context.itemUri) {
            const form = await fetchForm(context.itemUri);
            const rawValues = {
                ...parseFieldsOrAttributes(form.fields, shouldURIEncode, "ip"),
                ...parseFieldsOrAttributes(
                    form.attributes,
                    shouldURIEncode,
                    "ea"
                ),
            };
            return Object.assign(otherContext, rawValues);
        }
    } catch (e) {
        console.error("Error while withFormTokens", e);
    }
    return otherContext;
};

export { withFormTokens, parseFieldsOrAttributes };
